import { IconType } from "react-icons";
import {
  FaArrowRight,
  FaCommentsDollar,
  FaInstagram,
  FaMoneyBillWave,
  FaShareAlt,
  FaStore,
  FaUsers,
} from "react-icons/fa";

import { Button } from "@components/buttons/button";
import { Card } from "@components/cards/card";

type PartnerNetworkSectionProps = {
  onGoEntry: () => void;
};

type PartnerFeature = {
  icon: IconType;
  title: string;
  text: string;
  color: "primary" | "success" | "info" | "warning" | "danger";
};

const partnerFeatures: PartnerFeature[] = [
  {
    icon: FaShareAlt,
    title: "Links de divulgação",
    text: "Afiliados podem divulgar campanhas em seus perfis e gerar vendas por links identificados.",
    color: "primary",
  },
  {
    icon: FaMoneyBillWave,
    title: "Comissão automática",
    text: "Quando um parceiro vende, a comissão vai diretamente para a conta dele na plataforma.",
    color: "success",
  },
  {
    icon: FaCommentsDollar,
    title: "Negociação sem chat",
    text: "Percentuais podem ser solicitados, contrapropostos e aceitos por ambas as partes direto na plataforma.",
    color: "info",
  },
  {
    icon: FaUsers,
    title: "Perfis encontráveis",
    text: "Usuários e influenciadores podem cadastrar redes sociais para serem encontrados por donos de campanhas.",
    color: "primary",
  },
  {
    icon: FaStore,
    title: "Vitrine do afiliado",
    text: "Um perfil pode reunir todas as campanhas em que a pessoa atua, facilitando vendas em vários produtos.",
    color: "warning",
  },
  {
    icon: FaInstagram,
    title: "Redes sociais no perfil",
    text: "Links das principais redes sociais para aumentar a credibilidade e o alcance dos parceiros.",
    color: "danger",
  },
];

export function PartnerNetworkSection({
  onGoEntry,
}: PartnerNetworkSectionProps) {
  return (
    <section id="parceiros" className="landing-partner-section py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-5">
            <span className="badge bg-success bg-opacity-10 rounded-pill px-3 py-2 mb-3 fs-6">
              Rede de vendas
            </span>
            <h2 className="landing-partner-title fw-bold text-dark mb-3">
              Transforme parceiros e influenciadores em força de venda
            </h2>
            <p className="landing-partner-description text-muted mb-4">
              Convide pessoas para vender seus tickets com link próprio, defina o percentual de comissão, acompanhe a estimativa de lucro líquido e o parceiro recebe a comissão diretamente na plataforma.
            </p>
            <Button
              className="btn btn-primary rounded-4 text-white px-4 py-3 shadow-sm"
              onClick={onGoEntry}
            >
              Conheça todos os recursos
              <FaArrowRight className="ms-2" />
            </Button>
          </div>

          <div className="col-lg-7">
            <div className="landing-partner-grid row g-3">
              {partnerFeatures.map(({ icon: Icon, title, text, color }) => (
                <div className="col-md-4" key={title}>
                  <Card className="landing-partner-feature h-100 border shadow-sm p-3">
                    <Icon className={`landing-partner-icon text-${color} mb-3`} />
                    <h5 className="fw-bold text-dark mb-2">{title}</h5>
                    <p className="text-muted mb-0">{text}</p>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}